<template>
  <div :class="{'emi-index-contact-box': true, 'mobile': isMobile}">
    <h1 class="contact-box-title"> 留下您的联系方式，为您匹配的核心代理会尽快与您联络</h1>
    <el-form :model="formData" ref="form" :rules="rules" label-position="top" class="contact-form">
      <div v-for="item in formItems" :key="item.label" :class="{'contact-form-item': true, 'large': item.large}">
        <el-form-item :label="item.name" :prop="item.label" :required="item.required" :class="item.label">
          <el-input v-if="item.type === 'input'" v-model="formData[item.label]">
            <el-button v-if="item.label == 'telPhoneCode'" slot="append" :disabled="time > 0" @click="getVerifyCode"> {{verifyCodeText}}</el-button>
          </el-input>
          <template v-else-if="item.type === 'cascader'">
            <div class="coreproxy">
              <el-cascader v-model="formData[item.label]" :options="item.options" style="width: 100%;" @change="() => { clearValue(item.label)}"></el-cascader>
              <el-button @click="getCoreProxy">匹配核心代理</el-button>
            </div>
          </template>
          <el-select v-else v-model="formData[item.label]" style="width: 100%;">
            <el-option v-for="op in item.options" :value="op" :label="op" :key="op"></el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <div class="cardbox" v-if="coreProxy.length">
      <div class="card" v-for="(item,idx) in coreProxy" :class="{'ischecked':idx === active}" @click="checked(idx)">
        <h3 class="card_title" :title="item.agentName">{{ item.agentName }}</h3>
        <p class="card_text" :title="item.email">{{ item.email }}</p>
      </div>
    </div>
    <div class="form-action">
      <button class="contact-form-submit" @click="submit" :disabled="isSubmitDisabled"> 完成并提交</button>
    </div>
  </div>
</template>
<script>
  import axios from '../common/axios.js';
  export default {
    name: 'contact',
    data() {
      return {
        coreProxy:[],
        active:0,
        checkedCard:{agentName:'',agentEamil:''},
        mockIndustryData:[
          {
            value: 'internet',
            label: '互联网',
            children: [
              { value: 'ecommerce', label: '电商' },
              { value: 'game', label: '游戏' },
              { value: 'social', label: '社交' },
              { value: 'online-edu', label: '在线教育' },
            ],
          },
          {
            value: 'manufacture',
            label: '制造业',
            children: [
              { value: 'auto', label: '汽车制造' },
              { value: 'electronics', label: '电子制造' },
              { value: 'machinery', label: '机械设备' },
            ],
          },
          {
            value: 'finance',
            label: '金融',
            children: [
              { value: 'bank', label: '银行' },
              { value: 'securities', label: '证券' },
              { value: 'insurance', label: '保险' },
              { value: 'fund', label: '基金/资管' },
            ],
          },
          {
            value: 'service',
            label: '生活服务',
            children: [
              { value: 'catering', label: '餐饮' },
              { value: 'hotel', label: '酒店/旅游' },
              { value: 'logistics', label: '物流/快递' },
              { value: 'education', label: '教育培训' },
            ],
          },
        ],
        formItems: [
          {name: '姓名', required: true, large: false, label: 'contractName', type: 'input'},
          {name: '手机', required: true, large: false, label: 'telPhoneNum', type: 'input'},
          {name: '手机验证码', required: true, large: false, label: 'telPhoneCode', type: 'input'},
          {name: '公司名称', required: true, large: false, label: 'companyName', type: 'input'},
          {name: '公司所在地', required: true, large: false, label: 'province', type: 'select', options: ['安徽', '北京', '重庆', '福建', '甘肃', '广东', '广西', '贵州', '海南', '河北', '黑龙江', '河南', '湖北', '湖南', '江苏', '江西', '吉林', '辽宁', '内蒙古', '宁夏', '青海', '山东', '上海', '山西', '陕西', '四川', '天津', '新疆', '西藏', '云南', '浙江', '台湾', '香港', '澳门']},
          {name: '公司所属行业', required: true, large: false, label: 'industry', type: 'cascader', options: []},
        ],
        formData: {
          contractName: '',
          telPhoneNum: '',
          telPhoneCode: '',
          companyName: '',
          province: '',
          industry: [],
          agentEmail: '',
          agentName: ''
        },
        rules: {
          contractName: {
            required: true,
            message: '请输入姓名'
          },
          telPhoneNum: {
            required: true,
            validator: (rule, value, callback) => {
              if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号码'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
          telPhoneCode: {
            required: true,
            message: '请输入手机号验证码'
          },
          companyName: {
            required: true,
            message: '请输入公司名称'
          },
          province: {
            required: true,
            message: '请选择公司所在地'
          },
          industry: {
            required: true,
            message: '请选择公司所属行业'
          }
        },
        time: 0,
        isMobile: /iPhone|Android/ig.test(navigator.userAgent)
      }
    },
    computed: {
      verifyCodeText() {
        return this.time > 0 ? `重新发送(${this.time}s)` : '发送验证码';
      },
      isSubmitDisabled() {
       return this.formItems.filter(item => item.required).some(item => {
          const value = this.formData[item.label]
          if(Array.isArray(value)){
            return value.length === 0;
          }
          return !value;
        })
      },
    },
    created() {
      this.getIndustry();
    },
    methods: {
      async getVerifyCode() {
        if (this.time > 0 || !/^1[3456789]\d{9}$/.test(this.formData.telPhoneNum)) {
          return;
        }
        try {
          const res = await axios({
            url: '/account/textMessage/sendCode',
            method: 'get',
            params: {
              telPhoneNum: this.formData.telPhoneNum
            }
          });
          this.handleResult(res);
          
        } catch (e) {
          this.handleResult(e)
        }
      },
      handleResult(res) {
        if (res.success) {
          this.$message({
            message: '短信验证码已发送，有效期5分钟',
            type: 'success'
          });
          this.time = 120;
          let timer = setInterval(() => {
            this.time--;
            if (this.time <= 0) {
              clearInterval(timer);
              this.time = 0;
            }
          }, 1000);
        } else {
          this.$message({
            message: res.code == 0 ? '验证码发送失败' : res.failMsg || '无效的手机号码',
            type: 'error'
          });
        }
      },
      async submit() {
        console.log(this.formData,'ffffffffffff');
        if(!this.formData.agentName || !this.formData.agentEmail){
          this.$message({
            message:this.coreProxy.length>1?'请在匹配的2家代理中选择1家':'请确认公司所属行业后再次匹配核心代理',
            type:'error'
          })
          return
        }
     
        try {
          await this.$refs.form.validate();
          this.formData.industry = Array.isArray(this.formData.industry)
            ? this.formData.industry[1]
            : this.formData.industry;
          let res = await axios({
            url: '/account/coreAgentPublicity/publicityMessage',
            method: 'post',
            data: this.formData
          });
          if (res.success) {
            this.$message({
              message: res.result,
              type: 'success'
            });
            Object.keys(this.formData).forEach(key => {
              this.formData[key] = '';
            });
            this.$refs.form.resetFields();
          }
        } catch(err) {
          console.log(err,'eeeerrrr');
          
          if (err) {
            this.$message({
              message: err.failMsg || '提交失败，请稍后再试' ,
              type: 'error'
            });
          }
        }
      },
      async getIndustry() {
        try {
          let res = await axios({
            url: '/v5/account/getIndustryList'
          });
          if (res.success && res.result) {
            let industry = this.formItems.find(item => item.label === 'industry');
            industry.options = res.result.map(op => {
              return {
                label: op.lvl1CategoryName,
                value: op.lvl1CategoryName,
                children: op.lvl2CategoryList.map(item => {
                  return {
                    label: item.lvl2CategoryName,
                    value: item.lvl2CategoryName
                  }
                })
              }
            });
          }
        } catch (err) {
          console.log(err);
        }
      },
      async getCoreProxy() {
        try {
          this.$refs.form.validateField(['industry'], async (err) => {
            if (!err) {
              let res = await axios({
                url: '/v5/account/matchCoreAgent',
                method:'get',
                params:{lvl1CategoryName:this.formData.industry[0],lvl2CategoryName:this.formData.industry[1]}
              })
              
              this.coreProxy = res.result[0].agents
            }
            if (this.coreProxy.length === 1) {
              this.active = 0;
              this.formData.agentName = this.coreProxy[0].agentName;
              this.formData.agentEmail = this.coreProxy[0].email;
            } else {
              this.active = -1;
              this.formData.agentEmail = ''
              this.formData.agentName = ''
            }
          });

        } catch (err) {

        }
        
      },
      checked(idx){
        try{
          this.active = idx;
          this.formData.agentName = this.coreProxy[idx].agentName;
          this.formData.agentEmail = this.coreProxy[idx].email;
        }catch(err){

        }
    },
    clearValue(item) {
      console.log(item, 'clear')
      if (item === 'industry') {
        this.coreProxy = [];
        this.formData.agentName = '';
        this.formData.agentEmail = '';
        this.active = 0;
      }
    }
  },
}
</script>